import React from 'react';
import { TextLink } from '@dsg-tech/homefield-react';
import {
  HomefieldIconPlChevronDown,
  HomefieldIconPlChevronUp,
} from '@dsg-tech/homefield-react-icons';
import { checkStores, setDataEmTag } from '../../../../utility/utility';
import './AccordionFooter.scss';

export default function AccordionFooter({
  openAccordion,
  accordionCatData,
  footerAccordionHandler,
  accordionIndex,
  accordionKeyEventHandler,
}) {
  function createAriaLabel() {
    if (accordionCatData.n && accordionCatData.col) {
      if (!openAccordion) {
        return `Open ${accordionCatData.n} Accordion`;
      }
      return `Close ${accordionCatData.n} Accordion`;
    }
    return null;
  }

  const hasColumnData =
    accordionCatData.col && accordionCatData.col.length >= 1 && accordionCatData?.col?.[0]?.cats;
  return (
    <div className="accordion-container footer-accordion-container">
      <div className="accordion-container__accordion footer-accordion-container__accordion">
        <button
          type="button"
          tabIndex={0}
          id={accordionIndex}
          aria-expanded={openAccordion}
          aria-label={createAriaLabel() ?? ''}
          data-em={setDataEmTag('Footer', accordionCatData.n)}
          className="accordion-container__accordion--category footer-accordion-container__accordion--category hmf-body-bold-l hmf-px-s hmf-py-m"
          onClick={() => footerAccordionHandler(accordionIndex, accordionCatData)}
          onKeyDown={(e) => accordionKeyEventHandler(accordionIndex, accordionCatData, e)}>
          {accordionCatData.n}
          {accordionCatData.col &&
            (!openAccordion ? (
              <HomefieldIconPlChevronDown className="accordion-container__accordion--category--icon hmf-pr-xxs" />
            ) : (
              <HomefieldIconPlChevronUp className="accordion-container__accordion--category--icon hmf-pr-xxs" />
            ))}
        </button>
        <div
          aria-labelledby={`accordion-${accordionIndex}`}
          aria-hidden={!openAccordion}
          className={`accordion-container__accordion--sublink-container footer-accordion-container__accordion--sublink-container ${
            !openAccordion ? 'hmf-display-none' : 'hmf-display-flex'
          }`}>
          {hasColumnData &&
            accordionCatData.col[0].cats.map((link: any) => {
              return (
                <TextLink
                  key={`link-${link.n}`}
                  variant="group-inverse"
                  size="medium"
                  tabIndex={0}
                  data-em={setDataEmTag('Footer', link.n)}
                  className="hmf-p-m"
                  href={checkStores(link.u)}>
                  {link.n}
                </TextLink>
              );
            })}
        </div>
      </div>
    </div>
  );
}
